import { render, staticRenderFns } from "./Form_Detail.vue?vue&type=template&id=625f074b&scoped=true"
import script from "./Form_Detail.vue?vue&type=script&lang=js"
export * from "./Form_Detail.vue?vue&type=script&lang=js"
import style0 from "./Form_Detail.vue?vue&type=style&index=0&id=625f074b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625f074b",
  null
  
)

export default component.exports